import { TFilterSelected } from '@monorepo/types';
import { TFilterGroupModel, UiFilterModifiers } from '@monorepo/ui';
import { UTILS_GUARDS } from 'libs/ui/src/lib/filter/model/ui-filter.guards';

export const AQL_FILTER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    searchInOption: string,
    department: string,
    prevModel?: TFilterGroupModel<TFilterSelected>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isTargetDateFilter(item)) {
        return {
          type: 'TARGET_DATE_FILTER',
          key: item.key,
          displayName: item.displayName,
          values: item.values,
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isMultiSelectFilter(item)) {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            ...val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          ...(item.searchable && {
            searchWithApi: {
              searchService: 'aql',
              searchEndPoint: 'SEARCH_BCTX_V2',
              searchInOption: searchInOption,
              department: department,
            },
          }),
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          filteredOrgTree: {
            ...item,
            values: [],
          },
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }

      throw new Error('Type Not suppported');
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },

  filterUpdateByGroup(
    filterGroupModel: TFilterGroupModel<TFilterSelected>,
    groupModeInfo: TFilterGroupModel<TFilterSelected>['groups'][number],
  ) {
    return UiFilterModifiers.filterUpdateByGroup(filterGroupModel, groupModeInfo);
  },
};
